export const PROVIDER_FAIRSTONE = '1';
export const PROVIDER_WELLS_FARGO = '2';
export const PROVIDER_SYNCHRONY = '3';
export const PROVIDER_CAPITAL_ONE = '4';
export const PROVIDER_ALLIANCE_DATA_SERVICES = '5';
export const PROVIDER_AMERICAN_GENERAL_FINANCE = '6';
export const PROVIDER_ENCOMPASS = '8';
export const PROVIDER_TD_BANK = '9';
export const PROVIDER_GENESIS = '10';
export const PROVIDER_ATLANTICUS = '11';
export const PROVIDER_TIDEWATER_CREDIT_SERVICES = '12';
export const PROVIDER_SMART_SALES_AND_LEASE = '13';
export const PROVIDER_ACCEPTANCE_NOW = '14';
export const PROVIDER_REGIONAL_MANAGEMENT_CORP = '15';
export const PROVIDER_AMERICAN_FIRST_FINANCE = '16';
export const PROVIDER_WEST_CREEK_FINANCIAL = '17';
export const PROVIDER_SNAP_FINANCE = '18';
export const PROVIDER_ACIMA_CREDIT = '19';
export const PROVIDER_PROGRESSIVE_LEASING = '20';
export const PROVIDER_KORNERSTONE_CREDIT = '21';
export const PROVIDER_TOWER_LOAN = '22';
export const PROVIDER_GREAT_AMERICAN_FINANCE = '23';
